import * as React from "react";
import { cn } from "./utils";

export interface FormStatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    status: string;
}

const statusConfig = {
    published: {
        color: "bg-green-100 text-green-800 border-green-200",
        label: "Published",
    },
    draft: {
        color: "bg-yellow-100 text-yellow-800 border-yellow-200",
        label: "Draft",
    },
    archived: {
        color: "bg-gray-100 text-gray-800 border-gray-200",
        label: "Archived",
    },
    deprecated: {
        color: "bg-red-100 text-red-800 border-red-200",
        label: "Deprecated",
    },
};

const FormStatusBadge = React.forwardRef<HTMLSpanElement, FormStatusBadgeProps>(
    ({ className, status, ...props }, ref) => {
        const config = statusConfig[status.toLowerCase() as keyof typeof statusConfig];

        if (!config) {
            return (
                <span
                    ref={ref}
                    className={cn(
                        "inline-flex items-center bg-gray-100 px-2 py-1 border border-gray-200 rounded font-medium text-gray-800 text-xs capitalize",
                        className
                    )}
                    {...props}
                >
                    {status}
                </span>
            );
        }

        return (
            <span
                ref={ref}
                className={cn(
                    "inline-flex items-center px-2 py-1 border rounded font-medium text-xs",
                    config.color,
                    className
                )}
                {...props}
            >
                {config.label}
            </span>
        );
    }
);

FormStatusBadge.displayName = "FormStatusBadge";

export { FormStatusBadge };
